import JWPlayer from '@jwplayer/jwplayer-react';
import { useState, useEffect } from "react";
import { formatTime } from '../helpers/formatTime'
import { formatDate } from '../helpers/formatDate';
import SmallHighlightedVideo from "./SmallHighlightedVideo";
import { useNavigate } from 'react-router-dom';
import configData from '../config.json';


const SectionPage = ({ category,
    categoryList,
    activeCategory,
    setActiveCategory,
    setActiveVideo }) => {

    const [highlightedVideoList, setHighlightedVideoList] = useState([]);
    const [rerender, setRerender] = useState(true);

    useEffect(() => {

            var highlighted = [];
            var catActive = JSON.parse(localStorage.getItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY));

            if(JSON.parse(localStorage.getItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY)).videos.length < 3) {
                if(catActive.videos.length <2) {
                    highlighted.push(catActive.videos[0]);
                    highlighted.push(catActive.videos[0]);
                    highlighted.push(catActive.videos[0]);
                } else {
                    highlighted.push(catActive.videos[0]);
                    highlighted.push(catActive.videos[1]);
                    highlighted.push(catActive.videos[1]);
                }
            }
            else {
                highlighted.push(catActive.videos[0]);
                highlighted.push(catActive.videos[1]);
                highlighted.push(catActive.videos[2]);
            }

            setHighlightedVideoList(highlighted);
        
        
    }, [activeCategory]);

    useEffect(() => {
        setRerender(true)
    }, [activeCategory])

    useEffect(() => {
        if (rerender) {
            setRerender(false)
        }
    }, [rerender]);

    let navigate = useNavigate(); 
    const navigateTo = (path) =>{ 
        navigate(path);
    }

    const changeActiveVideo = (video) => {
    
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO_URL, JSON.stringify(video.url));
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(video));
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(activeCategory));

        setActiveVideo(video);
        setActiveCategory(activeCategory);
      };

    return (
        <>
            {!rerender && (
            <>
                <div className="container d-video-container">
                    <div className="row mb-3">
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col">
                                    <JWPlayer
                                        file={highlightedVideoList[0].url}
                                        library='https://cdn.jwplayer.com/libraries/uSnweboJ.js'
                                        image={highlightedVideoList[0].thumbnail}
                                    />
                                    <div id="videoInfo" className="d-hide-element">
                                        <p>Playlist id: {activeCategory.id}</p>
                                        <p>Media id: {highlightedVideoList[0].id}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ps-md-5 order-3 order-md-0 d-side-videos">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-12 mb-4 mb-md-0">
                                    <SmallHighlightedVideo video={highlightedVideoList[1]} 
                                                activeCategory={category}
                                                setActiveCategory={setActiveCategory}
                                                setActiveVideo={setActiveVideo}
                                                fromPage='section'
                                    />
                                </div>
                                <div className="col-12 col-sm-6 col-md-12 pt-md-2 mb-4 mb-md-0">
                                    <SmallHighlightedVideo video={highlightedVideoList[2]} 
                                                activeCategory={category}
                                                setActiveCategory={setActiveCategory}
                                                setActiveVideo={setActiveVideo}
                                                fromPage='section'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 mt-3 mb-5 mb-md-0 mt-md-n45" data-aos="fade-right" data-aos-delay="400">
                            <h2 className="d-ext-video-title" style={{"cursor": "pointer"}} onClick={() => {changeActiveVideo(highlightedVideoList[0]); navigateTo('/video/' + (category.flatName).replace(/\s/g, '-') + '/' + highlightedVideoList[0].id + '/' + (highlightedVideoList[0].flatTitle).replace(/\s/g, '-'));}}     >
                                <span className="d-text">{highlightedVideoList[0].title}</span> 
                                <label className="d-ext-video-duration">{formatTime(highlightedVideoList[0].duration)}</label>
                            </h2>
                            <label className="d-ext-video-date">{formatDate(highlightedVideoList[0].creationDate)}</label>
                            <div className="d-ext-video-description">{highlightedVideoList[0].description}</div>
                        </div>
                    </div>
                </div>
            </>
            )}
        </>

    );
};

export default SectionPage;